
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { i18nMixin } from '@/modules/neodash/mixins';
import {
  columnGoalSetting,
  EconomicGroup,
  IEconomicGroupGoalsDetails,
  Families,
  Family,
  inputColumnGoalSetting,
  inputManualColumnGoalSetting,
  labelColumnGoalSetting,
  numberColumnGoalSetting,
  numberValuedColumnGoalSetting,
  percentColumnGoalSetting,
} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import { GoalSettingColumns } from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';
import ValueEditionGoalSetting from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/value-edition-goal-setting.component.vue';
import { NumberHelper } from '@/utils/number.helper';
import { SaleTypeEnum } from '@/modules/neodash/model/types/enums/saleTypeEnum';
import { isInput, styleCellFactory } from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/utils';
import { goalTypeEnum } from '@/modules/business-plan/modules/models/enums/goalTypeEnum';
import Icon from '@/modules/business-plan/common/utils/icon.component.vue';
import numeral from 'numeral';

const t = i18nMixin.methods.i18n;

@Component({
  name: 'TableBodyGoalSettingComponent',
  components: { Icon, ValueEditionGoalSetting }
})
export default class TableBodyGoalSettingComponent extends Vue {
  public numeral = numeral;
  public isInput = isInput;
  private openedJustifications: number[] = [];

  @Prop({ required: true })
  public columns: GoalSettingColumns;

  @Prop({ required: true })
  public economicGroup: EconomicGroup;

  @Prop({ required: true })
  public families: Families;

  @Prop({ required: true })
  public needArbitratedGoalJustification: boolean;

  public styleCell = styleCellFactory(this.columns);

  public getValueArbitratedGoal(column: columnGoalSetting, family: Family): number | string {
    const lst: IEconomicGroupGoalsDetails[] = this.getSalesGroupIndustryGoalData(family);
    const sum = lst.filter(c => c.inputValue && c.inputValue > 0).sumBy(c => c.goalValue);

    return sum === 0 ? '' : sum;
  }

  public getValue(column: columnGoalSetting, family: Family): number | string {
    const { hide } = column as numberValuedColumnGoalSetting;
    if (hide && hide(family)) {
      return '';
    }

    const lst: IEconomicGroupGoalsDetails[] = this.getSalesGroupIndustryGoalData(family);

    if ((column as labelColumnGoalSetting).getterLabel)
      return (column as labelColumnGoalSetting).getterLabel(family);

    if ((column as numberColumnGoalSetting).getterValue)
      return lst.sumBy((column as numberColumnGoalSetting).getterValue);

    if ((column as percentColumnGoalSetting).getterOver) {
      const { familiesToHide } = this.columns;
      if (familiesToHide.includes(family.id)) {
        return '-';
      }

      const c = column as percentColumnGoalSetting;
      const total = lst.sumBy(c.getterTotal);
      const over = lst.sumBy(c.getterOver);

      if (c.withSubtract) {
        if (over === 0) {
          return numeral(0).format('0.0%');
        }

        return numeral((total / over) - 1).format('0.0%');
      }

      return NumberHelper.percent(total, over);
    }

    return 'Not registered';
  }

  public getInputShare(column: inputColumnGoalSetting, family: Family): string {
    const { hide } = column as numberValuedColumnGoalSetting;
    const { familiesToHide } = this.columns;
    if (hide && hide(family) || familiesToHide.includes(family.id))
      return '';

    const lst: IEconomicGroupGoalsDetails[] = this.getSalesGroupIndustryGoalData(family);

    if ((column as inputManualColumnGoalSetting).isManualInput) {
      if (lst.length > 1) {
        if (lst[0].goalTypeSelected !== goalTypeEnum.Manual && lst[1].goalTypeSelected !== goalTypeEnum.Manual)
          return '';
      } else {
        if (lst[0].goalTypeSelected !== goalTypeEnum.Manual) return '';
      }
    }

    const total = lst.sumBy(this.columns.getInputShareTotalProp);
    const over = lst.sumBy(column.getterOver);

    return NumberHelper.percent(total, over);
  }

  public handleClickCell(column: columnGoalSetting, family: Family): void {
    if (isInput(column)) return;

    this.toggleJustification(family);
  }

  public toggleJustification(family: Family): void {
    if (!this.justification(family)) return;

    const isShowingJustification = this.isShowingJustification(family);
    const old = this.openedJustifications;

    this.openedJustifications = isShowingJustification ? old.filter(x => x !== family.id) : [family.id, ...old];
  }

  public justification(family: Family): string {
    const goal = this.getSalesGroupIndustryGoalData(family)[0];
    if (!goal) return '';

    return goal.justification || goal.justificationTotal;
  }

  public isShowingJustification(family: Family): boolean {
    return this.openedJustifications.some(x => x === family.id);
  }

  public changeValue(idFamily: number, idSaleType: number, value: number) {
    console.log('emit received.', idFamily, idSaleType, value);
    this.$nextTick(() => {
      this.getSalesGroupIndustryGoalData(this.families.findOrFirst(x => x.id === idFamily))[0].inputValue = value;
    });
  }

  private getSalesGroupIndustryGoalData = (family: Family): IEconomicGroupGoalsDetails[] =>
    {
      return this.economicGroup.details.filter(
        x => (x.idSaleType===this.columns.saleType.value||this.columns.saleType.value===SaleTypeEnum.AllOfIt)&&
          x.idFamily===family.id);
    };
}
